import * as React from "react";

import { useGetSvgIconFill } from "@intelligems/ig-theme/hooks/use-get-svg-icon-fill";
import { SvgIcon, SvgIconProps } from "@mui/material";

export const StatMinus = (props: SvgIconProps) => {
  const fill = useGetSvgIconFill(props.color);

  return (
    <SvgIcon {...props}>
      <svg
        width={35}
        height={35}
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <rect width={35} height={35} rx={5} fill="white" />
        <rect width={35} height={35} rx={5} fill={fill} fillOpacity={0.08} />

        <g mask="url(#mask0_60218_101984)">
          <path
            d="M17.5 24.5001L11.5 18.5001L12.9 17.1001L17.5 21.6751L22.1 17.1001L23.5 18.5001L17.5 24.5001ZM17.5 18.5001L11.5 12.5001L12.9 11.1001L17.5 15.6751L22.1 11.1001L23.5 12.5001L17.5 18.5001Z"
            fill={fill}
            fillOpacity={0.38}
          />
        </g>
      </svg>
    </SvgIcon>
  );
};
